import authRequest from "@/api/http/authRequest";

export default {
  // 리스트 (페이지네이션)
  list(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.get(`/admin/team-leader-access-codes`, params, cb, errCb)
  },
  // 상세 조회
  get(id: number, cb: (response) => void, errCb: (response) => void) {
    authRequest.get(`/admin/team-leader-access-code/${id}`, {}, cb, errCb)
  },
  // 생성
  create(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.post(`/admin/team-leader-access-code`, params, cb, errCb)
  },
  // 수정
  update(params: any, cb: (response) => void, errCb: (response) => void) {
    authRequest.patch(`/admin/team-leader-access-code/${params.id}`, params, cb, errCb)
  },
  // 삭제
  delete(id: number, cb: (response) => void, errCb: (response) => void) {
    authRequest.delete(`/admin/team-leader-access-code/${id}`, cb, errCb)
  },
  // 활성화
  activate(id: number, cb: (response) => void, errCb: (response) => void) {
    authRequest.patch(`/admin/team-leader-access-code/${id}/activate`, {}, cb, errCb)
  },
  // 비활성화
  deactivate(id: number, cb: (response) => void, errCb: (response) => void) {
    authRequest.patch(`/admin/team-leader-access-code/${id}/deactivate`, {}, cb, errCb)
  },
}
